import { app as firebase } from '@/firebase/firebase';
import { createEmailPasswordUser } from "./firebase/auth";
import { httpsCallable } from "@/firebase/functions";

export const ROLE_ADMIN = 0;
export const ROLE_MANAGER = 1;
export const ROLE_USER = 2;

export async function createEmailUser(name, email, password) {
    const user = await createEmailPasswordUser(email, password, name);
    const userInfo = await setUserInfo(user.uid, email, name);
    // todo save to store here
    // Resignin user to refresh user's info
    await firebase.auth().signOut()
    await firebase.auth().signInWithEmailAndPassword(email, password)
    return userInfo;
}

async function setUserInfo (userId, email, name) {
    let userInfo = {
        id: userId,
        uid: userId,
        name: name,
        email: email,
        emailVerified: false,
        isAnonymous : false,
        root: false,
        role: 0,
        photoURL: '',
        blocked : false,
        main : true,
        notify : { newBill : false, newOrder : false, help : true } 
    }
    userInfo.photoURL = await updatePhotoURL();
    await firebase.firestore().collection('user').doc(userId).set(userInfo);
    return userInfo;
}

async function updatePhotoURL () {
    let storageRef = firebase.storage().ref().child(`users/photos/no-photo.png`)
    let photoURL   = await storageRef.getDownloadURL()
    return photoURL;
}

export async function createInvite (companyId) {
    const call = httpsCallable('createInvitation');
    await call({ companyId });
}

export async function associateUserToCompany (companyId, user, role = ROLE_USER) {
    user.uid = user.id || user.uid;
    const association = {
        ...user,
        blocked: false,
        role,
        main: false,
        notify: {
            help: true,
            newBill: true,
            newOrder: true,
        },
        invitedAt: new Date()
    };
    await firebase.firestore().collection('company').doc(companyId).collection('companyUsers').doc(user.id).set(association)
}